import { Constructor } from './constructor';

export const isInstanceOf = <T>(
  object: T,
  instance: Constructor<T>,
): object is T => {
  return object instanceof instance;
};
